import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=67b5e0a8&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5e0a8",
  null
  
)

export default component.exports